import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { withFacebookLogin } from "@quintype/bridgekeeper-js";

import SocialAuthButton from "../social-auth-button";

const FacebookAuth = () => {
  const publisherAttributes = useSelector(state => get(state, ["qt", "config", "publisher-attributes"], {}));
  const redirectUrl = window ? window.location.href : "";
  const appId = get(publisherAttributes, ["socialAuth", "fb"], "");

  const { serverSideLoginPath } = withFacebookLogin({
    scope: "email",
    emailMandatory: true,
    appId: appId,
    redirectUrl: encodeURIComponent(redirectUrl)
  });

  return <SocialAuthButton type="fb" href={serverSideLoginPath} />;
};

export default FacebookAuth;
